// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-camera-perm {
  position: fixed;
  top: calc(8px + env(safe-area-inset-top, 0px));
  left: 8px;
  right: 8px;
  z-index: 1100;
  max-width: 420px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(15, 23, 42, 0.94);
  color: #f8fafc;
  border: 1px solid rgba(46, 230, 166, 0.35);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.35);
}

.lt-camera-perm__copy {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.78rem;
  line-height: 1.35;
}

.lt-camera-perm__copy p {
  margin: 0;
}

.lt-camera-perm__btn {
  align-self: stretch;
  min-height: 40px;
  border: 0;
  border-radius: 10px;
  background: #2ee6a6;
  color: #0f172a;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
}

.lt-camera-perm__btn:disabled {
  opacity: 0.7;
  cursor: wait;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/EvalCameraPermissionBanner.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,8CAA8C;EAC9C,SAAS;EACT,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd","sourcesContent":[".lt-camera-perm {\n  position: fixed;\n  top: calc(8px + env(safe-area-inset-top, 0px));\n  left: 8px;\n  right: 8px;\n  z-index: 1100;\n  max-width: 420px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: rgba(15, 23, 42, 0.94);\n  color: #f8fafc;\n  border: 1px solid rgba(46, 230, 166, 0.35);\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.35);\n}\n\n.lt-camera-perm__copy {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 0.78rem;\n  line-height: 1.35;\n}\n\n.lt-camera-perm__copy p {\n  margin: 0;\n}\n\n.lt-camera-perm__btn {\n  align-self: stretch;\n  min-height: 40px;\n  border: 0;\n  border-radius: 10px;\n  background: #2ee6a6;\n  color: #0f172a;\n  font-size: 0.85rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.lt-camera-perm__btn:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
